import { CommitmentsDeathService_deathServiceV2PostSimulate } from '@festina/life-general-types/life/hooks/CommitmentsDeathService_deathServiceV2PostSimulate'

export const useLazyFetchDeathSimulation =
  CommitmentsDeathService_deathServiceV2PostSimulate.useLazyQuery
